import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import { b as _extends, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import Tooltip from '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import NavBar from '../NavBar/NavBar.js';
import CommandButton from './CommandButton.js';

const PrimaryItemsDiv = styled(Div)`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
`;

const SecondaryItemsDiv = styled(Div)`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  flex-shrink: 0;
  align-items: stretch;
`;

function CommandBar({
  items = [],
  farItems = [],
  styles = {}
}) {
  const theme = useTheme();
  const onRenderItems = itemsToRender => {
    return itemsToRender.map((item, index) => {
      const itemText = item.text || item.name;
      if (item.onRender) {
        return item.onRender(item);
      }
      const commandButtonProps = _objectSpread2(_objectSpread2({
        key: item === null || item === void 0 ? void 0 : item.key,
        testId: 'commandBarItem',
        children: !item.iconOnly ? itemText : undefined
      }, item), {}, {
        styles: styles.item ? {
          root: styles.item
        } : item.styles
      });
      if (item.iconOnly && itemText !== undefined) {
        return /*#__PURE__*/createElement(Tooltip, _extends({
          key: item.key || index,
          message: itemText
        }, item.tooltipProps), /*#__PURE__*/createElement(CommandButton, _extends({
          key: item.key || index,
          testId: "commandBarItem"
        }, commandButtonProps)));
      }
      return /*#__PURE__*/createElement(CommandButton, _extends({
        key: item.key || index
      }, commandButtonProps));
    });
  };
  return /*#__PURE__*/createElement(NavBar, _extends({
    height: theme.shape.headerBottomHeight,
    minHeight: theme.shape.headerBottomHeight,
    bg: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    zIndex: theme.zIndex.commandBar
  }, styles.root), /*#__PURE__*/createElement(PrimaryItemsDiv, styles.leftSide, onRenderItems(items)), /*#__PURE__*/createElement(Div, {
    flexGrow: "1"
  }), farItems && farItems.length !== 0 && /*#__PURE__*/createElement(SecondaryItemsDiv, styles.rightSide, onRenderItems(farItems)));
}

export default CommandBar;
